<template>
  <div
    class="bg-white cs-container"
    style="width: 680px; min-width: 680px; max-width: 680px"
    id="estimate-print"
  >
    <div class="mb-5 w-full text-right noprint">
      <button class="btn-print" @click="onPrint">출력하기</button>
      <button class="ml-1 btn-print" @click="onBack">뒤로이동</button>
    </div>

    <div class="flex mb-3">
      <div class="inline-block w-1/2">
        <div class="pb-2 border-b" style="width: 18rem">
          <h1 class="inline-block text-2xl font-bold">임 시 견 적 (ESTIMATION)</h1>
        </div>
        <div class="mt-2" style="width: 18rem">
          <p class="text-right">{{ estimate.clientCompany }}</p>
        </div>

        <div class="inline-block mt-5 text-3xs">
          <p>귀사의 일익 번창하심을 기원합니다.</p>
          <p class="mt-1">문의하신 제품 제작에 대한 예산 내역서를 제출하오니</p>
          <p class="mt-1">업무 참조 바랍니다.</p>
        </div>
      </div>
      <div class="flex justify-end w-1/2">
        <div class="inline-block mt-9" style="width: 17rem">
          <p class="text-xl font-bold">하이쓰리디(HY3D)</p>
          <div class="mt-5 text-3xs">
            <p>사업자등록번호: 480-81-01029</p>
            <p class="mt-1">업태: 제조업, 서비스업</p>
            <p class="mt-1">소재: 경기도 안산시 상록구 사동 한양대학로 55</p>
            <p class="mt-1">한양대학교 erica캠퍼스 창업보육센터 204호</p>
            <p class="mt-1">연락처: 031-436-8029</p>
          </div>
          <p class="mt-2 text-right text-2xs">대표이사 이정욱</p>
        </div>
      </div>
    </div>

    <!-- <div class="flex">
      <div class="inline-block w-2/3 text-3xs">
        <p>귀사의 일익 번창하심을 기원합니다.</p>
        <p class="mt-1">문의하신 제품 제작에 대한 예산 내역서를 제출하오니</p>
        <p class="mt-1">업무 참조 바랍니다.</p>
      </div>
      <div class="inline-block w-1/3">
        <p class="text-xl font-bold">하이쓰리디(HY3D)</p>
        <div class="mt-5 text-3xs">
          <p>사업자등록번호: 480-81-01029</p>
          <p class="mt-1">업태: 제조업, 서비스업</p>
          <p class="mt-1">소재: 경기도 안산시 상록구 사동 한양대학로 55</p>
          <p class="mt-1">한양대학교 erica캠퍼스 창업보육센터 204호</p>
          <p class="mt-1">연락처: 031-436-8029</p>
        </div>
        <p class="mt-2 text-right text-2xs">대표이사 이정욱</p>
      </div>
    </div> -->

    <div class="mt-20">
      <p class="font-bold">□ 합계금액 : ₩ {{ totalCost }}</p>
    </div>

    <div class="mt-8">
      <p class="font-bold">1. {{ estimate.clientCompany }} 제작</p>
    </div>
    <div class="mt-1">
      <table class="tg tb-1 text-2xs">
        <thead>
          <tr>
            <th class="tg-0lax" rowspan="2">No</th>
            <th class="tg-0lax" rowspan="2">내역</th>
            <th class="tg-0lax" colspan="2">단가</th>
            <th class="tg-0lax" rowspan="2">금액(원)</th>
          </tr>
          <tr>
            <th class="tg-0lax th-c-q">수량</th>
            <th class="tg-0lax th-c-p-">금액(원)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="tg-0lax">1</td>
            <td class="tg-0lax">{{ 0 < models.length ? models[0].name : "" }}</td>
            <td class="tg-0lax">{{ 0 < models.length ? models[0].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 0 < models.length ? numberToComma(models[0].modelCost) : "" }}
            </td>
            <td class="tg-0lax" rowspan="10">
              {{ numberToComma(estimate.buildCost ? estimate.buildCost : 0) }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">2</td>
            <td class="tg-0lax">{{ 1 < models.length ? models[1].name : "" }}</td>
            <td class="tg-0lax">{{ 1 < models.length ? models[1].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 1 < models.length ? numberToComma(models[1].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">3</td>
            <td class="tg-0lax">{{ 2 < models.length ? models[2].name : "" }}</td>
            <td class="tg-0lax">{{ 2 < models.length ? models[2].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 2 < models.length ? numberToComma(models[2].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">4</td>
            <td class="tg-0lax">{{ 3 < models.length ? models[3].name : "" }}</td>
            <td class="tg-0lax">{{ 3 < models.length ? models[3].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 3 < models.length ? numberToComma(models[3].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">5</td>
            <td class="tg-0lax">{{ 4 < models.length ? models[4].name : "" }}</td>
            <td class="tg-0lax">{{ 4 < models.length ? models[4].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 4 < models.length ? numberToComma(models[4].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">6</td>
            <td class="tg-0lax">{{ 5 < models.length ? models[5].name : "" }}</td>
            <td class="tg-0lax">{{ 5 < models.length ? models[5].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 5 < models.length ? numberToComma(models[5].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">7</td>
            <td class="tg-0lax">{{ 6 < models.length ? models[6].name : "" }}</td>
            <td class="tg-0lax">{{ 6 < models.length ? models[6].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 6 < models.length ? numberToComma(models[6].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">8</td>
            <td class="tg-0lax">{{ 7 < models.length ? models[7].name : "" }}</td>
            <td class="tg-0lax">{{ 7 < models.length ? models[7].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 7 < models.length ? numberToComma(models[7].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">9</td>
            <td class="tg-0lax">{{ 8 < models.length ? models[8].name : "" }}</td>
            <td class="tg-0lax">{{ 8 < models.length ? models[8].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 8 < models.length ? numberToComma(models[8].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">10</td>
            <td class="tg-0lax">{{ 9 < models.length ? models[9].name : "" }}</td>
            <td class="tg-0lax">{{ 9 < models.length ? models[9].modelCount : "" }}</td>
            <td class="tg-0lax">
              {{ 9 < models.length ? numberToComma(models[9].modelCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="4">동시제작 할인비용</td>
            <td class="tg-0lax">
              -{{ estimate.discountCost ? numberToComma(estimate.discountCost) : "" }}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="4">소계</td>
            <td class="tg-0lax">
              {{
                numberToComma(estimate.buildCost ? estimate.buildCost - estimate.discountCost : 0)
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-8">
      <p class="font-bold">2. 총계</p>
    </div>
    <div class="mt-1">
      <table class="tg tb-2 text-2xs">
        <thead>
          <tr>
            <th class="tg-0lax">No</th>
            <th class="tg-0lax">내역</th>
            <th class="tg-0lax">출력</th>
            <th class="tg-0lax">후처리</th>
            <th class="tg-0lax">도색</th>
            <th class="tg-0lax">배송</th>
            <th class="tg-0lax">합계</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="tg-0lax">1</td>
            <td class="tg-0lax">{{ estimate.clientCompany }}</td>
            <td class="tg-0lax">{{ numberToComma(estimate.buildCost - estimate.discountCost) }}</td>
            <td class="tg-0lax">{{ numberToComma(estimate.postProcessCost) }}</td>
            <td class="tg-0lax">{{ numberToComma(estimate.paintCost) }}</td>
            <td class="tg-0lax">{{ numberToComma(estimate.shippingCost) }}</td>
            <td class="tg-0lax">{{ supplyPrice }}</td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="6">공급가액</td>
            <td class="tg-0lax">{{ supplyPrice }}</td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="6">V.A.T</td>
            <td class="tg-0lax">{{ vat }}</td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="6"><span class="font-bold">최종금액</span></td>
            <td class="tg-0lax">
              <span class="font-bold">{{ totalCost }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="page-break-after: always"></div>

    <div class="mt-5">
      <div class="text-2xs">
        <p>1. 대금 지불기준</p>
        <p class="mt-1">: 3D 출력제작 비용 선납</p>
        <div class="mt-4 mb-4"></div>
        <p>2. 제작기간</p>
        <p class="mt-1">: 상호 합의하에 일정 조정 가능</p>
        <div class="mt-4 mb-4"></div>
        <p>3. 프린팅 제작</p>
        <p class="mt-1">
          : 출력 진행시 수정 및 중단이 불가하며, 제작기간 이후의 제품에 대해서 A/S 지원 불가
        </p>
        <div class="mt-4 mb-4"></div>
        <p>4. 임시 견적</p>
        <p class="mt-1">
          : 본 견적은 임시 견적으로 제품에 따라 검토 후 데이터 오류, 추가 작업에 따라 견적 금액이
          변경 될 수 있습니다
        </p>
      </div>
      <div class="flex justify-end mt-10">
        <div class="flex justify-between w-60 text-xs font-bold">
          <p>견적일자:</p>
          <p>{{ todayDate }}</p>
        </div>
      </div>
    </div>

    <!-- <div class="w-full h-full">
      <div class="mt-5 w-full">
        <div class="overflow-hidden rounded-md border border-b-2 estimate-content border-line">
          <div class="px-7 py-3 bg-black">
            <img class="sub-logo" src="../assets/images/logo.png" />
          </div>
          <div class="px-7 py-5 bg-white border-b border-line">
            <div class="flex justify-between">
              <p class="text-placeholder1">출력 비용</p>
              <p class="text-right">{{ numberToComma(estimate.modelCost ? estimate.modelCost : 0) }} 원</p>
            </div>
            <div class="flex justify-between mt-2">
              <p class="text-placeholder1">배송 비용</p>
              <p class="text-right">{{ shippingCost }} 원</p>
            </div>
          </div>
          <div class="px-7 py-5 bg-white">
            <div class="flex font-normal">
              <div class="w-full">
                <p class="font-semibold">총 비용(예상)</p>
                <p class="mt-2 text-desc">비용은 변동될 수 있습니다.</p>
              </div>
              <p class="w-full text-4xl font-bold text-right text-second">{{ totalCost }} 원</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 w-full">
        <client-model v-for="(model, index) in models" :key="model.id" :model="model" :enterIndex="index"> </client-model>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {storeToRefs} from "pinia";
import {EstimateStore} from "../store/estimate-store";
import {ModelStore} from "../store/model-store";
import {OptionsStore} from "../store/options-store";
import {numberToComma, dateConvertYMDHM_KR} from "../js/utils";
import {useRoute} from "vue-router";

const route = useRoute();
const optionsStore = OptionsStore();
const estimateStore = EstimateStore();
const {estimate} = storeToRefs(estimateStore);
const {models} = storeToRefs(ModelStore());

const todayDate = computed(() => {
  return dateConvertYMDHM_KR(Date.now() / 1000);
});
const supplyPrice = computed(() => {
  return numberToComma(
    estimate.value.buildCost +
      estimate.value.postProcessCost +
      estimate.value.paintCost +
      estimate.value.shippingCost -
      estimate.value.discountCost
  );
});
const totalCost = computed(() => {
  const vat = Math.floor(
    (estimate.value.buildCost +
      estimate.value.postProcessCost +
      estimate.value.paintCost +
      estimate.value.shippingCost -
      estimate.value.discountCost) *
      0.1
  );
  return models.value.length
    ? numberToComma(
        estimate.value.buildCost +
          estimate.value.postProcessCost +
          estimate.value.paintCost +
          estimate.value.shippingCost -
          estimate.value.discountCost +
          vat
      )
    : 0;
});
const vat = computed(() => {
  return numberToComma(
    Math.floor(
      (estimate.value.buildCost +
        estimate.value.postProcessCost +
        estimate.value.paintCost +
        estimate.value.shippingCost -
        estimate.value.discountCost) *
        0.1
    )
  );
});

onMounted(async () => {
  await optionsStore.reqGetOptions();

  let estimateId = route.query.estimateId;
  if (!estimateId) {
    estimateId = estimate.value.id;
  }

  estimateStore.reqGetEstimate(estimateId);
});

const onPrint = () => {
  window.print();
};
const onBack = () => {
  window.close();
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sub-logo {
  height: 30px;
}

.upload-area {
  transition: 0.2s all;

  &:hover {
    border: 1px solid #c5e1ff;
    background-color: #f7fbff;
  }
}

.unit-unactive {
  background-color: rgb(243 244 246);
}

.estimate-content {
  top: 1rem;
}

.btn-print {
  @apply px-3 py-2 rounded-sm border border-stone-200 text-sm;
  background-color: #ececec;
}

.tg {
  border-collapse: collapse;
  border-spacing: 0;

  width: 100%;
}
.tg td {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  padding: 3px 5px 1px;
  font-weight: 500;
  word-break: normal;
}
.tg th {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  padding: 5px 5px 2px;
  font-weight: 500;
  word-break: normal;
}
.tg .tg-0lax {
  vertical-align: middle;
}

.tb-1 tr {
  &:first-child {
    th {
      &:nth-child(1) {
        min-width: 30px;
      }
      &:nth-child(2) {
        width: 100%;
      }
      &:nth-child(3) {
        min-width: 180px;
      }
      &:nth-child(4) {
        min-width: 100px;
      }
    }
  }
  &:last-child {
    th {
      width: 50%;
    }
  }

  td {
    height: 34px;
    padding: 3px 5px 1px;
    text-align: center;
  }
}

.tb-2 tr {
  &:first-child {
    th {
      &:nth-child(1) {
        min-width: 30px;
      }
      &:nth-child(2) {
        width: 100%;
      }
      &:nth-child(3) {
        min-width: 80px;
      }
      &:nth-child(4) {
        min-width: 80px;
      }
      &:nth-child(5) {
        min-width: 80px;
      }
      &:nth-child(6) {
        min-width: 80px;
      }
      &:nth-child(7) {
        min-width: 80px;
      }
    }
  }

  td {
    height: 34px;
    padding: 3px 5px 1px;
    text-align: center;
  }
}

@media print {
  .noprint {
    display: none;
  }
}
</style>
